import axiosInstance from "./httpInterceptor";

export const rdService = {
  /**
   * Fetch pre-scraped and LLM-analysed clinical trials for a competitor.
   * @param {string} competitorId - MongoDB company ID of the selected competitor,
   *                                or "market" to retrieve all competitors' trials.
   */
  getTrials: (competitorId) =>
    axiosInstance.get("/v1/clinical-trials", {
      params: { competitorId },
    }),

  /**
   * Trigger an immediate scrape for all managed competitors (ADMIN only).
   * Returns 202 Accepted immediately — scraping runs asynchronously.
   */
  runScraper: () =>
    axiosInstance.post("/v1/clinical-trials/scraper/run"),
};
